import React from "react"
import { useTranslation } from "react-i18next"
import useControllerNavegation from "../../hooks/useControllerNavegation"
import Menu from "../../components/Menu/Menu"
import logo from "../../assets/images/Erro404.png"

const NotFound: React.FC = () => {
  const { t } = useTranslation(["404Erro", "frontend"])

  const { goToHome } = useControllerNavegation()

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col">
      <Menu />

      <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
        <img src={logo} alt="404" className="w-72 md:w-[420px] drop-shadow-xl" />

        <h1 className="mt-8 text-2xl md:text-3xl font-bold text-slate-800">{t("label_title_erro")}</h1>

        <p className="mt-4 text-slate-500 max-w-md">{t("frontend:not_found.description")}</p>

        <button
          onClick={goToHome}
          className="mt-10 px-8 py-3 rounded-xl bg-red-500 hover:bg-orange-600 text-white font-semibold shadow-md hover:shadow-lg transition-all duration-300"
          data-interaction-description-key="interactionDescriptions:pages.notFound.404Erro.button.goToHome"
        >
          {t("buttons:button_go_to_start")}
        </button>
      </div>
    </div>
  )
}

export default NotFound
